import { useEffect, useMemo } from "react";
import { useAccessibleUserAccounts } from "../../../components/Common/HelperComponents/CustomHooks";
import { useOrganizations } from "../../../components/Common/HelperComponents/GetDataFromStore";
import { useDispatch, useSelector } from "react-redux";
import { getTagDetails, getTagAllocationAccounts } from "../../../store/tagAllocation/tagAllocationSlice";
import jwt_decode from "jwt-decode";

export const useUserAccountsInfo = () => {
  const accounts = useAccessibleUserAccounts();
  const organizations = useOrganizations();

  // Extract orgCode
  const orgCode = useMemo(() => organizations?.[0]?.orgcode, [organizations]);

  // Extract username
  let username;
  if (localStorage.getItem("authUser")) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const authUser = jwt_decode(obj.idToken);
    const email = authUser.email;
    username = email;
  }

  return { orgCode, username };
};

export const useTagAllocationAccounts = () => {
  const dispatch = useDispatch();
  
  // Selecting tag allocation accounts and loading/error state from the store
  const { 
    tagAllocationAccounts, 
    isFetchingTagAllocationAccounts, 
    fetchTagAllocationAccountsError 
  } = useSelector((state) => state.tags);
  
  console.log("🚀 ~ useTagAllocationAccounts ~ tagAllocationAccounts:", tagAllocationAccounts)

  useEffect(() => {
    dispatch(getTagAllocationAccounts());
  }, [dispatch]);

  // Ensure we always return an array, even if the data is malformed
  const safeTagAllocationAccounts = Array.isArray(tagAllocationAccounts) ? tagAllocationAccounts : [];

  return { 
    tagAllocationAccounts: safeTagAllocationAccounts, 
    isFetchingTagAllocationAccounts, 
    fetchTagAllocationAccountsError 
  };
};

export const useTagDetails = (accountNumber) => {
  const dispatch = useDispatch();
  const { orgCode, username } = useUserAccountsInfo(); // Reuse the hook

  // Selecting tag details and loading/error state from the store
  const { tagDetails, isFetchingTagDetails, fetchTagDetailsError } = useSelector(
    (state) => state.tags
  );

  useEffect(() => {
    if (orgCode && accountNumber && username) {
      dispatch(getTagDetails({ orgCode, accountNumber, username }));
    }
  }, [dispatch, orgCode, accountNumber, username]);

  return { tagDetails, isFetchingTagDetails, fetchTagDetailsError };
};